import { AxiosInstance } from "axios"
import { MeetingServicePriceListsItem, PriceListFavoriteItem } from "./priceListsTypes"

export enum MeetingServicePriceListsQuery {
    USER_MEETING_SERVICE_PRICE_LISTS = "meeting-service-priceLists-for-user",
    USER_MEETING_SERVICE_PRICE_LISTS_FAVORITES = "meeting-service-priceLists-favorites-for-user",
}

type MeetingServicePriceListsParam = Readonly<{
    userId: number
}>

export type MeetingServicePriceListsResponse = Readonly<{
    merchants: MeetingServicePriceListsItem[]
}>

export async function fetchMeetingServicePriceListsForUser(
    { userId }: MeetingServicePriceListsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<MeetingServicePriceListsResponse> {
    const url = `users/${userId}/orders/meetingService/priceLists`
    const { data } = await axios.get(url, {
        signal,
        params: {},
    })

    return data
}

type PriceListFavoritesParam = Readonly<{
    userId: number
}>

export type PriceListFavoritesResponse = Readonly<{
    merchants: PriceListFavoriteItem[]
}>

export async function fetchPriceListFavorites(
    { userId }: PriceListFavoritesParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<PriceListFavoritesResponse> {
    const url = `users/${userId}/pricelistFavorite`
    const { data } = await axios.get(url, {
        signal,
        params: {},
    })

    return data
}

type SavePriceListFavoriteParam = Readonly<{
    userId: number
    merchants: PriceListFavoriteItem[]
}>

export type SavePriceListFavoriteResponse = Readonly<{}>

export async function savePriceListFavorite(
    { userId, ...content }: SavePriceListFavoriteParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<SavePriceListFavoriteResponse> {
    const { data } = await axios.post(
        `users/${userId}/pricelistFavorite`,
        {
            ...content,
        },
        {
            signal,
        },
    )
    return data
}
